var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('canvas',{ref:"qrCanvas"}),_c('v-btn',{staticClass:"white--text",attrs:{"rounded":"","x-large":"","color":"black","loading":_vm.isPrinting},on:{"click":_vm.printQRCode}},[_vm._v(" "+_vm._s(_vm.$t('print-qr-code'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }